// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { iconLinkCommonStyles } from "@adl/XDL/Utilities/links";
import { hideElement } from "@adl/XDL/Utilities/sharedStyles";
import { dealerInformationStyles } from "@insite/content-library/Widgets/DealerDetails/DealerInformation";
import ChevronLeft from "@insite/mobius/Icons/ChevronLeft";
import ExternalLink from "@insite/mobius/Icons/ExternalLink";
import MapPin from "@insite/mobius/Icons/MapPin";
import Phone from "@insite/mobius/Icons/Phone";
import { css } from "styled-components";

dealerInformationStyles.container = {
    gap: 10,
};

dealerInformationStyles.addressInfoIcon = {
    css: css`
        ${hideElement}
    `,
};

dealerInformationStyles.addressInfoCondensed = {
    wrapper: {
        css: css`
            font-style: normal;
        `,
    },
};

dealerInformationStyles.phoneLink = { ...iconLinkCommonStyles(Phone) };

dealerInformationStyles.googleMapsDirectionLink = { ...iconLinkCommonStyles(MapPin) };

dealerInformationStyles.googleMapsDirectionLinkGridItem = {
    width: 5,
};

dealerInformationStyles.visitWebsiteLink = { ...iconLinkCommonStyles(ExternalLink) };

dealerInformationStyles.nameGridItem = {
    width: 12,
};

dealerInformationStyles.nameText = {
    variant: "h1",
    css: css`
        margin-bottom: 0;
    `,
};

dealerInformationStyles.htmlContentGridItem = {
    width: 12,
    css: css`
        order: 1;
        padding-top: 30px;
    `,
};

dealerInformationStyles.visitWebsiteLinkGridItem = {
    css: css`
        display: none;
    `,
};

dealerInformationStyles.selectedDealerDisplayBackToResultsLink = { ...iconLinkCommonStyles(ChevronLeft) };
